// extracted by mini-css-extract-plugin
export default {"header":"index_header__KtkKp"};